import { useEffect, useState } from 'react';
import { Check, Mail, Undo2, X } from 'lucide-react';
import { useI18n } from '../lib/i18n';
import { descartarAviso, deshacerEnvio, pendientes, suscribir, type EnvioPendiente } from '../lib/envioConDeshacer';

/**
 * LA VENTANITA DE ABAJO A LA IZQUIERDA (pedido 2026-10-08, "como MCP"): por cada email encolado,
 * "Sending to … in 8 s" con Undo; al salir, "Sent"; si falla, se queda con el error hasta cerrarla.
 */
export function UndoSendHost() {
  const { t } = useI18n();
  const [lista, setLista] = useState<EnvioPendiente[]>(pendientes());
  useEffect(() => suscribir(() => setLista(pendientes())), []);
  if (lista.length === 0) return null;
  return (
    <div aria-live="polite" style={{ position: 'fixed', left: 16, bottom: 16, zIndex: 'var(--z-modal-top)', display: 'grid', gap: 8, maxWidth: 'min(420px, calc(100vw - 32px))' }}>
      {lista.map((e) => (
        <div key={e.id} role="status" style={{ background: 'var(--ink)', color: 'var(--bg)', borderRadius: 12, padding: '10px 12px', boxShadow: 'var(--shadow-lg, var(--shadow))', display: 'grid', gap: 6 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {e.estado === 'enviado' ? <Check size={16} strokeWidth={2} style={{ color: 'var(--green)', flexShrink: 0 }} /> : <Mail size={16} strokeWidth={1.75} style={{ flexShrink: 0, opacity: 0.85 }} />}
            <div style={{ flex: 1, minWidth: 0, fontSize: 'var(--fs-sm)', lineHeight: 1.35 }}>
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.etiqueta}</div>
              <div style={{ fontSize: 'var(--fs-2xs)', opacity: 0.8 }}>
                {e.estado === 'esperando' && t('undo.sendingIn', { n: e.restante })}
                {e.estado === 'enviando' && t('undo.sendingNow')}
                {e.estado === 'enviado' && t('undo.sent')}
                {e.estado === 'fallo' && `${t('undo.failed')} ${e.error ?? ''}`}
              </div>
            </div>
            {e.estado === 'esperando' && (
              <button type="button" onClick={() => deshacerEnvio(e.id)}
                style={{ background: 'var(--bg)', color: 'var(--ink)', border: 'none', borderRadius: 8, padding: '6px 12px', fontWeight: 700, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 'var(--fs-sm)' }}>
                <Undo2 size={14} strokeWidth={2} /> {t('undo.undo')}
              </button>
            )}
            {e.estado === 'fallo' && (
              <button type="button" aria-label="close" onClick={() => descartarAviso(e.id)} style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 4 }}><X size={14} strokeWidth={2} /></button>
            )}
          </div>
          {e.estado === 'esperando' && (
            <div style={{ height: 3, borderRadius: 2, background: 'rgba(255,255,255,0.18)', overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${(e.restante / 10) * 100}%`, background: 'var(--accent)', transition: 'width 1s linear' }} />
            </div>
          )}
          {e.estado === 'esperando' && <div style={{ fontSize: 'var(--fs-2xs)', opacity: 0.6 }}>{t('undo.navHint')}</div>}
        </div>
      ))}
    </div>
  );
}
